import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_MODES } from './device-detection.constants';
import { ClientManagerService } from '../client-manager/client-manager.service';
import { getBrowser, getOS } from '../../utilities/device-utilities';
import { PaceInsightsService } from '@evorait/pace-logging';

@Injectable()
export class DeviceContextInterceptor implements HttpInterceptor {
    private readonly browserInfo: string;
    private readonly osInfo: string;

    public constructor(
        private clientManagerService: ClientManagerService,
        private paceInsights: PaceInsightsService,
    ) {
        this.browserInfo = getBrowser();
        this.osInfo = getOS();
    }

    public intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        const appMode = this.getAppMode(); // check dynamically on each request
        // traceparent already carries trace/span; the session id has no standard header,
        // so it has to ride along explicitly for the server to log the same scope.
        const sessionId = this.paceInsights.getSessionId();
        const modifiedReq = req.clone({
            setHeaders: {
                'pace-os': this.osInfo,
                'pace-browser': this.browserInfo,
                'pace-mode': appMode,
                'pace-appversion': this.clientManagerService.getAppVersion(),
                ...(sessionId ? { 'pace-session-id': sessionId } : {}),
            },
        });

        return next.handle(modifiedReq);
    }

    private getAppMode(): string {
        return this.clientManagerService.isPacePWAStandalone() ? APP_MODES.STANDALONE : APP_MODES.BROWSER;
    }
}
